import { ReactElement } from 'react'

import { RestaurantPageProps } from '~/components/Restaurant/RestaurantPage/RestaurantPageView'
import { getCanonicalForPath, paths } from '~/constants'
import Layout from '~/layout'
import { getDefaultMetadatas } from '~/layout/Head/HeadUtils'

export function getRestaurantPageLayout(page: ReactElement<RestaurantPageProps>) {
  const name = page.props.restaurant?.name
  const slug = page.props.restaurant?.slug

  return (
    <Layout
      metadata={{
        ...getDefaultMetadatas(),
        title: `${name || 'Restaurant'} | RestaurantClub`,
        canonical: getCanonicalForPath(paths.singleRestaurant({ slug })),
      }}>
      {page}
    </Layout>
  )
}
